import React from "react";
import Home from "../../components/home/Home";
import AboutHome from "../../components/about/AboutGalery";
import FormHome from "../../components/form/FormHome";
import Product from "../../components/product/Product";

const HomePage = () => {
  return (
    <div className="homePage_container">
      <Home />
      <Product />
      <AboutHome />
      <FormHome />
    </div>
  );
};

export default HomePage;
